<template>
<div>
  <div class="wistia_embed wistia_async_nirn52pe1l">
    &nbsp;
  </div>

  <div
    id="mindful_meditation"
    class="tbk-vid-embed"
  >
    <a
      id="female"
      class="embedded_video"
      href="#wistia_8y1s3be1aa?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="male"
      class="embedded_video"
      href="#wistia_j5rp1pd0ik?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('nir', 13, this.showSelect)

    this.tbk.loadCrossTime('j5r', 312, this.showSelect)
    this.tbk.loadCrossTime('8y1', 322, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        j5r: this.tbk.autoPlay,
        '8y1': this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('.tbk-vid-embed').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style scoped lang="sass">
#mindful_meditation
  display: none
  a
    text-decoration: none
#male
  position: absolute
  top: calc(100% * (134 / 360))
  left: calc(100% * (345 / 640))
  width: calc(100% * (158 / 640))
  height: calc(100% * (140 / 360))
#female
  position: absolute
  top: calc(100% * (134 / 360))
  left: calc(100% * (135 / 640))
  width: calc(100% * (158 / 640))
  height: calc(100% * (140 / 360))
</style>

